import RcsUtils from '../utils/RcsUtils';

class BlogBox {
  render() {
    let disp = [];
    let dataElements = Array.from(document.querySelectorAll('article.bk_box_002'));
    if (dataElements !== null) {
      dataElements.forEach(element => {
        let dateElement = element.querySelector('.data');
        if (dateElement === null) {
          return;
        }

        let mese;
        let monthForum;
        let yearForum;
        let dayForum;
        let string = dateElement.textContent;
        let stringN = this.stringCount(string);
        let dateRandom = Math.floor(99 + Math.random() * 100);
        if (stringN === 3) {
          dayForum = string.substring(0, string.indexOf(' '));
          monthForum = string.substring(string.indexOf(' ') + 1, string.lastIndexOf(' '));
          yearForum = string.substring(string.lastIndexOf(' ') + 1);
        } else if (stringN === 4) {
          let splitStr = string.split(' ');
          dayForum = splitStr[1];
          monthForum = splitStr[2];
          yearForum = splitStr[3];
        }
        switch (monthForum) {
          case 'gennaio':
            mese = '01';
            break;
          case 'febbraio':
            mese = '02';
            break;
          case 'marzo':
            mese = '03';
            break;
          case 'aprile':
            mese = '04';
            break;
          case 'maggio':
            mese = '05';
            break;
          case 'giugno':
            mese = '06';
            break;
          case 'luglio':
            mese = '07';
            break;
          case 'agosto':
            mese = '08';
            break;
          case 'settembre':
            mese = '09';
            break;
          case 'ottobre':
            mese = '10';
            break;
          case 'novembre':
            mese = '11';
            break;
          case 'dicembre':
            mese = '12';
            break;
          default:
            break;
        }

        element.setAttribute(
          'data-id-pubdate',
          `${yearForum}${mese}${dayForum}0${dateRandom}`
        );
        // Element.setAttribute('data-id-pubdate222', `${yearForum}${mese}${dayForum}0000`);
      });
    }

    let articleElements = Array.from(document.querySelectorAll('.sorttab article'));
    if (articleElements !== null) {
      let inc = 10;
      articleElements.forEach(element => {
        let firstElement = Array.from(
          element.querySelectorAll('.articleBlog .primo-piano li')
        );

        if (firstElement !== null) {
          firstElement = firstElement[0];
          if (typeof firstElement !== 'undefined') {
            let elementToClone = firstElement.querySelector('a');
            if (elementToClone !== null) {
              let clonedElement = elementToClone.cloneNode(true);
              element.querySelector('.new-forum-link').innerHTML = '';
              element.querySelector('.new-forum-link').appendChild(clonedElement);
            }
          }
        }
        let lastMessageElement = element.querySelector('.data-last-mess');
        if (lastMessageElement !== null) {
          lastMessageElement.parentNode.removeChild(lastMessageElement);
        }

        let pElement = element.querySelector('.box-forum-desc p');
        if (pElement !== null) {
          let textRub = pElement.textContent.trim();
          if (textRub.length > 51) {
            pElement.textContent = textRub.substring(0, 60) + '...';
          }
        }
        element.setAttribute(
          'data-id-pubdate',
          element.getAttribute('data-id-pubdate') + inc
        );
        let pubDate = element.getAttribute('data-id-pubdate');
        if (pubDate) {
          disp.push(pubDate);
        }
        inc++;
      });
    }

    disp.sort();
    for (let k = 0; k < disp.length; k++) {
      let containerElement = document.querySelector('.md_bx_c5 .sorttab');
      if (containerElement !== null) {
        let pubElement = containerElement.querySelector(`[data-id-pubdate="${disp[k]}"]`);
        if (pubElement !== null) {
          containerElement.insertBefore(pubElement, containerElement.firstChild);
          RcsUtils.addClass(pubElement, `item-${k}`);
        }
      }
    }
  }

  stringCount(string) {
    let splittedString = string.split(' ');
    let count = 0;
    splittedString.forEach(() => {
      count++;
    });

    return count;
  }
}

module.exports = BlogBox;



// WEBPACK FOOTER //
// ./src/rcs_cor_hp-lazy-loading/boxes/BlogBox.js